
export default {

    ALL_ROUTES: '*',

    ADMINLOGIN: '/adminLogin',

    ENACH_SIGNDESK: '/smandate/:loanId',
    ENACH_SIGNDESK_MOBILE: '/mandatemobile/:loanId',
    FEEDBACK: '/feedback/:userId',
    UPLOAD_DOCUMENT: '/uploadDocuments/:userId',

    E_NACH_PAGE: '/enach/:loanId',
    E_NACH_EV_PAGE: '/enachEv/:loanId',
    E_SIGN_NACH_PAGE: '/esignEnach/:loanId',

    ENACH_BY_CASHFREE: '/enach/cashfree/:loanId',
    ENACH_BY_CASHFREE_EV: '/enach/cashfreeEv/:loanId',
    E_SIGN_PAGE: '/esign/:loanId',
    E_SIGN_SIGNZY_PAGE: '/esignSignzy/:loanId',
    E_SIGN_KARZA_PAGE: '/totalKyc/esign/:loanId',
    E_SIGN_PAGE_EV: '/esignEv/:loanId',

    Reference: '/userReference/:userId',

    E_NACH_PAGE_MOBILE: '/enachMobile/:loanId',
    E_SIGN_PAGE_MOBILE: '/esignMobile/:loanId',
    SEIGNDESK_REDIRECT_URL: '/signdeskmandate',

    KYC_FORM: '/kyc/:userId',
    KYC_MOBILE: '/kycMobile/:userId',
    KYC_SIGNZY: '/kycSignzy/:userId',
    KYC_SIGNZY_NEW: '/kyc/Signzy/:userId',
    DIGILOCKER_KYC: '/digikyc/:userId',
    KYC_DIGITAP: '/kycDigitap/:userId',

    KFS_PAGE: '/kfs/:loanId',
    KYC_FORM_DIGILOCKER: '/kycDigilocker/*',
    KFS_PAGE_NEW: '/kfsnew/:loanId',

    LEGAL_NOTICE: '/legalnotice/:loanId',
    ESIGN_REDIRECT_URL: '/redirectUser',
    ESIGN_REDIRECT_KARZA_URL: '/redirectUser/karza',
    // UPLOAD_DOCUMENT_REDIRECT: '/uploadDocumentsRedirect',
    ESIGN_REDIRECT_URL_SIGNZY: '/redirectUserSignzy',

    CRIF_URL: '/crif',
    ESIGN_REDIRECT_URL_EV: '/redirectUserEVCallback',
    SOA: '/soa/:loanId',
    SOA_EV: '/soaEv/:loanId',
    E_NACH_PAGE_UPI: '/enach/upi/:loanId',


    VIEW_TRANSACTION_RECIEPT: '/transactionReciept/:paymentId',

    LOAN_AGGREGEMENT_LINK: '/loanAggrement/:loanId',
    UPLOAD_DOCUMENT_REDIRECT: '/uploadDocumentsRedirect/:userId/:success',

    KYC_REDIRECT_URL: '/redirectKYCUser', //signzy
    KYC_REDIRECT_URL_DIGITAP: '/redirectKYCUserDigitap', // digitap

    AGGREGTOR_REDIRECTION_URL: '/redirectAggregator', // aggregator

    E_SIGN_PAGE_DIGITAP: '/esign/digitap/:loanId',
    ESIGN_REDIRECT_DIGITAP_URL: '/redirectUserDigitap',

};